export function encodeQueryData(data: any) {
  const ret = [];
  for (const d in data) {
    if (true) {
      ret.push(`${encodeURIComponent(d)}=${encodeURIComponent(data[d])}`);
    }
  }
  return ret.join('&');
}
